import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_PASSWORD = "empty_password";
export const ERROR_PASSWORDS_NOT_MATCH = "passwords_not_match";

export default formWithMessages(props => {
  const { onSave, disabled } = props;
  return (
    <Form
      formProps={{
        id: `change-password-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        password: {
          uiProps: {
            type: "password",
            placeholder: "Password",
            maxLength: 100,
          },
          position: 1,
          initialValue: "",
          label: "Password",
        },
        repeatPassword: {
          uiProps: {
            type: "password",
            placeholder: "Repeat password",
            maxLength: 100,
          },
          position: 2,
          initialValue: "",
          label: "Repeat password",
        },
      }}
      validation={formData => {
        if (!formData.password) return ERROR_EMPTY_PASSWORD;
        if (formData.password !== formData.repeatPassword)
          return ERROR_PASSWORDS_NOT_MATCH;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_PASSWORD]: "Password can't be empty",
        [ERROR_PASSWORDS_NOT_MATCH]: "Passwords don't match",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/ChangePassword.js